/**
 * Created by henian.xu on 2018/7/19.
 *
 */

import Member from './Member';
import MemberLevel from './MemberLevel';
import GrowthValueRule from './GrowthValueRule';
import PointRule from './PointRule';
import Enterprise from './Enterprise';
import EnterpriseCooperation from './EnterpriseCooperation';
import MemberDiscountCode from './MemberDiscountCode';
import MemberDiscount from './MemberDiscount';
import MemberApplyMaterials from './MemberApplyMaterials';
import Feedback from './Feedback';
import CooperationMember from './CooperationMember';
import EnterprisePracticeMaterials from './EnterprisePracticeMaterials';
import MemberApplyNotice from './MemberApplyNotice';
import SettlementRules from './SettlementRules';

export default {
    Member,
    MemberLevel,
    GrowthValueRule,
    PointRule,
    Enterprise,
    EnterpriseCooperation,
    MemberDiscountCode,
    MemberDiscount,
    MemberApplyMaterials,
    Feedback,
    CooperationMember,
    EnterprisePracticeMaterials,
    MemberApplyNotice,
    SettlementRules,
};
